import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ForumTopicPostActions from './ForumTopicPostActions';
import AuthorBlock from '../../components/User/AuthorBlock';
import ForumAttachList from './ForumAttachList';
import { selectedTextInPost, parseText } from '../../utils/helpers';
import MessageModal from '../../components/Modals/MessageModal';

export default class ForumTopicComment extends Component {
  static propTypes = {
    comment: PropTypes.shape({
      id: PropTypes.number.isRequired,
      userId: PropTypes.string.isRequired,
      createDate: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      attachments: PropTypes.array,
    }).isRequired,
    setBlockquote: PropTypes.func.isRequired,
    topic: PropTypes.object.isRequired,
    handleMobileShowTextEditor: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      showModalMessage: false,
      ModalMessage: '',
    };
  }

  handleReplyClick = () => {
    const fullname = `${this.props.comment.user.firstName} ${this.props.comment.user.lastName}`;
    this.props.setBlockquote({
      text: this.props.comment.text.replace(/<blockquote[^>]*>(.*)<\/blockquote>/g, ''),
      author: fullname,
      callback: this.props.handleMobileShowTextEditor
    });
  };

  handleCiteClick = () => {
    const fullname = `${this.props.comment.user.firstName} ${this.props.comment.user.lastName}`;
    const selectedText = selectedTextInPost(this.commentText, 'post-content__reply');
    if (selectedText) {
      this.props.setBlockquote({
        text: selectedText,
        author: fullname,
        callback: this.props.handleMobileShowTextEditor
      });
    } else {
      this.setState({
        showModalMessage: true,
        modalMessage: 'Выделите текст для цитирования этого сообщения',
      });
    }
  };

  render() {
    const { comment, topic } = this.props;
    const { showModalMessage, modalMessage } = this.state;
    const {
      userId, createDate, text, attachments, user,
    } = comment;
    const { isOpen } = topic;
    const { blockquote, reply } = parseText(text);
    return (
      <div className="theme__post" id={comment.id}>
        <AuthorBlock
          user={user}
          dateFormat="full"
          createDate={createDate}
          className="theme__post-author -xm"
          // toPost={`${paths.advocates.forumTopic}/${topic.alias}#${comment.id}`}
        />

        <div className="theme__post-content">
          <div className="post-content__text wysiwyg">
            {blockquote ? (
              <blockquote
                className="post-content__blockquote"
                dangerouslySetInnerHTML={{ __html: blockquote }}
              />
            ) : (
              ''
            )}

            <div
              className="post-content__reply"
              ref={(el) => {
                this.commentText = el;
              }}
              dangerouslySetInnerHTML={{ __html: reply }}
            />
          </div>

          {attachments && attachments.length ? <ForumAttachList attachments={attachments} /> : ''}
        </div>
        {isOpen ? (
          <ForumTopicPostActions
            handleReplyClick={this.handleReplyClick}
            handleCiteClick={this.handleCiteClick}
          />
        ) : (
          ''
        )}
        <MessageModal
          visible={showModalMessage}
          message={modalMessage}
          hide={() => {
            this.setState({ showModalMessage: false });
          }}
        />
      </div>
    );
  }
}
